import { render, staticRenderFns } from "./TransportVehicleArchivePage.vue?vue&type=template&id=72ba10ef"
import script from "./TransportVehicleArchivePage.vue?vue&type=script&lang=js"
export * from "./TransportVehicleArchivePage.vue?vue&type=script&lang=js"
import style0 from "./TransportVehicleArchivePage.vue?vue&type=style&index=0&id=72ba10ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports